import theme1 from '../cometchat-calls-override.css?url';
import theme3 from '../cometchat-calls-override3.css?url';
import theme4 from '../cometchat-calls-override4.css?url';
import theme5 from '../cometchat-calls-override5.css?url';
import theme6 from '../cometchat-calls-override6.css?url';
import theme7 from '../cometchat-calls-override7.css?url';
import theme8 from '../cometchat-calls-override8.css?url';
import theme9 from '../cometchat-calls-override9.css?url';

const STORAGE_KEY = 'cometchat-calls-theme';
const LINK_ID = 'cometchat-calls-theme-link';

const THEMES: string[] = [
  '', // 0 = default (no override)
  theme1,
  theme3,
  theme4,
  theme5,
  theme6,
  theme7,
  theme8,
  theme9,
];

export function getCurrentTheme(): number {
  return parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
}

export function setTheme(index: number) {
  const link = document.getElementById(LINK_ID) as HTMLLinkElement | null;

  if (index === 0) {
    link?.remove();
    localStorage.setItem(STORAGE_KEY, '0');
    return;
  }

  const href = THEMES[index];
  if (link) {
    link.href = href;
  } else {
    const el = document.createElement('link');
    el.id = LINK_ID;
    el.rel = 'stylesheet';
    el.href = href;
    document.head.appendChild(el);
  }

  localStorage.setItem(STORAGE_KEY, String(index));
}

export function nextTheme(): number {
  const current = getCurrentTheme();
  const next = (current + 1) % THEMES.length;
  setTheme(next);
  return next;
}

export function initTheme() {
  setTheme(getCurrentTheme());
}
